Confirm = require 'app/scripts/views/lib/confirm'
PopOver = require 'app/scripts/views/lib/pop-over'
l = require 'app/scripts/lib/localize'
{ track } = require '@trello/analytics'

module.exports = ({ trackingArea, elem, message, params }) ->
  track(trackingArea, "Denied", message)
  Confirm.toggle message,
    elem: elem
    html: l "confirm.#{message}.text", params
    fxConfirm: => PopOver.hide()
